import React from "react";
import { FiBriefcase, FiBookOpen } from "react-icons/fi";

const workExperience = [
  {
    company: "CHECK24 Vergleichsportal Mietwagen GmbH",
    role: "Software Developer",
    period: "Sep 2022 – Present",
    location: "Augsburg, Germany",
    description: [
      "Working on an enterprise-grade car rental comparison platform serving millions of users.",
      "Full-stack development using PHP (Laminas & Symfony frameworks), React and modern JavaScript.",
      "Building and maintaining CI/CD pipelines via Bitbucket Pipelines for reliable, automated deployments.",
      "Containerizing services with Docker in a microservices-oriented architecture.",
      "Collaborating in an agile Scrum team with a strong focus on code quality and peer review.",
    ],
    tags: ["PHP", "Laminas", "Symfony", "React", "Docker", "CI/CD", "Bitbucket Pipelines", "CSS", "JavaScript", "TypeScript", "Webpack", "Tailwind CSS", "HTML", "Redis", "Redux", "nginx"],
  },
  {
    company: "SprintEins GmbH",
    role: "Frontend Developer",
    period: "2020 – 2022",
    location: "Augsburg, Germany",
    description: [
      "Development of frontend components within a microservices architecture.",
      "Implementation of UI layouts based on React and Material-UI.",
      "Building applications with Vue.js using modern component methodologies.",
    ],
    tags: ["React", "Vue.js", "TypeScript", "Material-UI", "SCSS", "Docker"],
  },
  {
    company: "Elitsoft Ingeniería y Asesorías Informáticas",
    role: "BI Process Analyst & Software Developer",
    period: "Apr 2016 – Nov 2017",
    location: "Santiago de Chile",
    description: [
      "Analysis and automation of business processes for Latam Airlines.",
      "QA: review of Teradata, Datastage and Pentaho code under development standards.",
      "Installation and execution in test (Beta) and production environments.",
    ],
    tags: ["Teradata", "Datastage", "Pentaho", "QA", "Linux server administration", "Vim"],
  },
  {
    company: "Paygol SPA",
    role: "Internship – Programmer & System Analyst",
    period: "Oct 2014 – Mar 2015",
    location: "Santiago de Chile",
    description: [
      "System development and maintenance using PHP, JavaScript, HTML5, CSS and MySQL.",
    ],
    tags: ["PHP", "JavaScript", "MySQL", "HTML5", "CSS"],
  },
];

const education = [
  {
    institution: "AIEP – Universidad Andrés Bello",
    degree: "Programmer and System Analyst",
    period: "2012 – 2014",
    location: "Santiago de Chile",
    description:
      "Graduated with distinction. Core curriculum in software development, relational databases, systems architecture and project management.",
  },
];

export default function Resume() {
  return (
    <section className="resume" id="resume">
      <div className="section__container">
        <div className="section__header">
          <span className="section__index">02</span>
          <div>
            <span className="section__tag">Experience / Journey</span>
            <h2 className="section__title">A decade of learning, shipping and improving.</h2>
          </div>
        </div>

        <div className="resume__grid">
          <div className="resume__col">
            <div className="resume__col-header">
              <FiBriefcase />
              <h3>Work Experience</h3>
            </div>
            <div className="timeline">
              {workExperience.map((job, i) => (
                <article className={`timeline__item${i === 0 ? " timeline__item--current" : ""}`} key={job.company}>
                  <div className="timeline__dot"></div>
                  <div className="timeline__content">
                    <span className="timeline__period">{job.period}</span>
                    <h4 className="timeline__title">{job.role}</h4>
                    <p className="timeline__company">{job.company}</p>
                    <p className="timeline__location">{job.location}</p>
                    <ul className="timeline__list">
                      {job.description.map((d, j) => (
                        <li key={j}>{d}</li>
                      ))}
                    </ul>
                    <div className="timeline__tags">
                      {job.tags.map((t) => (
                        <span className="timeline__tag" key={t}>
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="resume__col">
            <div className="resume__col-header">
              <FiBookOpen />
              <h3>Education</h3>
            </div>
            <div className="timeline">
              {education.map((edu) => (
                <article className="timeline__item" key={edu.institution}>
                  <div className="timeline__dot"></div>
                  <div className="timeline__content">
                    <span className="timeline__period">{edu.period}</span>
                    <h4 className="timeline__title">{edu.degree}</h4>
                    <p className="timeline__company">{edu.institution}</p>
                    <p className="timeline__location">{edu.location}</p>
                    <p className="timeline__desc">{edu.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
